import {
  COMPANIES_SLUG,
  CURRENT_VALUATIONS_SLUG,
  DASHBOARD_SLUG,
  INFORMATION_SLUG,
  MODELS_SLUG,
  OPERATIONS_SLUG,
  OPPORTUNITIES_SLUG,
  OVERVIEW_SLUG,
  PAST_VALUATIONS_SLUG,
  PREVIOUS_REPORTS_SLUG,
  SETTINGS_SLUG,
  SUBSCRIPTION_SLUG,
  WORKBOARD_SLUG,
} from 'dashboard409a/common/constants';

const DASHBOARD_COMPANY_URL = (companySlug: string) => `/${DASHBOARD_SLUG}/${COMPANIES_SLUG}/${companySlug}`;

export const dashboardCompanyOverviewUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OVERVIEW_SLUG}`;

export const dashboardCompanyPreviousReportsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${PREVIOUS_REPORTS_SLUG}`;

export const dashboardCompanySettingsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${SETTINGS_SLUG}`;

export const dashboardCompanySubscriptionUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${SUBSCRIPTION_SLUG}`;

export const dashboardCompanyInformationUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${INFORMATION_SLUG}`;

export const dashboardCompanyOperationsUrl = (companySlug: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OPERATIONS_SLUG}`;

export const dashboardCompanyOperationsValuationUrl = (companySlug: string, valuationId: string) =>
  `${DASHBOARD_COMPANY_URL(companySlug)}/${OPERATIONS_SLUG}/${valuationId}`;

const WORKBOARD_URL = `/${WORKBOARD_SLUG}`;

export const WORKBOARD_CURRENT_VALUATIONS_URL = `${WORKBOARD_URL}/${CURRENT_VALUATIONS_SLUG}`;
export const WORKBOARD_PAST_VALUATIONS_URL = `${WORKBOARD_URL}/${PAST_VALUATIONS_SLUG}`;
export const WORKBOARD_OPPORTUNITIES_URL = `${WORKBOARD_URL}/${OPPORTUNITIES_SLUG}`;
export const WORKBOARD_MODELS_URL = `${WORKBOARD_URL}/${MODELS_SLUG}`;
export const WORKBOARD_ACCOUNT_SETTINGS_URL = `${WORKBOARD_URL}/account-settings`;
export const WORKBOARD_AUDIT_LOGS_URL = `${WORKBOARD_URL}/audit-logs`;
export const WORKBOARD_ASSIGNMENT_RULES_URL = `${WORKBOARD_URL}/assignment-rules`;
